import { ApiRequest } from "./base";

const apiRoute = "logout";

export const LogoutApi = {
	async Logout() {
		return ApiRequest(`${apiRoute}`, "GET");
	}
};
